export function technology(){
    const container = document.querySelector('.technology-items') as HTMLElement | null;
    if (container) {
        const items = Array.from(container.children) as HTMLElement[];

        /**
         * Возвращает число колонок в гриде (.technology-items)
         */
        const getColumnCount = (): number => {
            const style = getComputedStyle(container);
            const columns = style.gridTemplateColumns.split(' ').length;
            return columns || 1;
        };

        /**
         * Убирает все классы
         */
        const clearClasses = (): void => {
            items.forEach(el => el.classList.remove('hovered', 'neighbor'));
        };

        /**
         * Обрабатывает наведение
         */
        const handleMouseOver = (e: MouseEvent): void => {
            const target = e.target as HTMLElement;
            if (!target.classList.contains('technology-item')) return;

            clearClasses();

            const index = items.indexOf(target);
            const columns = getColumnCount();

            target.classList.add('hovered');

            // Индексы соседей
            const top = index - columns;
            const bottom = index + columns;
            const left = index % columns !== 0 ? index - 1 : null;
            const right = (index + 1) % columns !== 0 ? index + 1 : null;

            [top, bottom, left, right].forEach(i => {
                if (i != null && items[i]) {
                    items[i].classList.add('neighbor');
                }
            });
        };

        const handleMouseLeave = (): void => {
            clearClasses();
        };

        container.addEventListener('mouseover', handleMouseOver);
        container.addEventListener('mouseleave', handleMouseLeave);
    }
}